module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M30 0H2C.894 0 0 .894 0 2v28c0 1.106.894 2 2 2h28c1.106 0 2-.894 2-2V2c0-1.106-.894-2-2-2zM14 23a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4zm0-10a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4zm10 10a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1v-4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4zm0-10a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v4z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/window-2.js
// module id = 1503
// module chunks = 14